export default __webpack_public_path__ + "static/media/dustbin_icon-white.01d36b99.svg";